import React from "react";
import codex from "../assets/projectAssets/codex.gif";
import "../styles/project.css";
const Codex = () => {
  return (
    <>
      <div className="project-content">
        <h2>Codex</h2>
        <a href="https://github.com/DhruvGupta3377/codex" target="_blank">
          SourceCode
        </a>
        <img src={codex} />
        <h3>Technologies used</h3>
        Tauri, Rust, ReactJS, JavaScript, HTML, CSS
        <h3>Why?</h3>
        <li>Notetaking Apps like obsidian are packed with features but take too much RAM.</li>
        <li>Markdown doesn't have a feature to give colour to text.</li>
        <li>Current app doesn't allow you to have keybindings for every thing.</li>
        <h3>What is this?</h3>
        <li>
          Created a markdown-inspired note-taking application, leveraging Tauri,
          Rust, and ReactJS for the frontend.
        </li>
        <li>
          It adheres to a set of rules similar to markdown, with a Rust-based
          custom parser converting text to HTML, based on these rules.
        </li>
        <li>
          The frontend, built in ReactJS, utilizes the Solarized theme for a
          visually appealing user experience.
        </li>
        <li>
          The application includes shortcuts for file operations, mode changes,
          and new file creation.
        </li>
        <li>Can easily be build for Unix/Linux or Windows environments.</li>
        <h3>What I learned?</h3>
        <li>First time buling a desktop application.</li>
        <li>Learned a alot about rust.</li>
        <li>Learned about parsers.</li>
      </div>
    </>
  );
};

export default Codex;
